/**
 * Minimal ABI fragments for the Uniswap V4 Quoter contract.
 *
 * Only includes quoteExactInputSingle — the function used to get
 * accurate swap quotes via on-chain simulation.
 *
 * The Quoter simulates the actual swap path (including tick-boundary
 * crossing) without costing gas, returning the exact output amount.
 */

export const quoterAbi = [
	{
		type: "function",
		name: "quoteExactInputSingle",
		inputs: [
			{
				name: "params",
				type: "tuple",
				internalType: "struct IQuoter.QuoteExactSingleParams",
				components: [
					{
						name: "poolKey",
						type: "tuple",
						internalType: "struct PoolKey",
						components: [
							{ name: "currency0", type: "address", internalType: "Currency" },
							{ name: "currency1", type: "address", internalType: "Currency" },
							{ name: "fee", type: "uint24", internalType: "uint24" },
							{ name: "tickSpacing", type: "int24", internalType: "int24" },
							{ name: "hooks", type: "address", internalType: "contract IHooks" },
						],
					},
					{ name: "zeroForOne", type: "bool", internalType: "bool" },
					{ name: "exactAmount", type: "uint128", internalType: "uint128" },
					{ name: "hookData", type: "bytes", internalType: "bytes" },
				],
			},
		],
		outputs: [
			{ name: "amountOut", type: "uint256", internalType: "uint256" },
			{ name: "gasEstimate", type: "uint256", internalType: "uint256" },
		],
		stateMutability: "nonpayable",
	},
] as const;
